import { Button, Icon, Input } from "@deligoo/ui"
import clsx from "clsx"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"

import { Card } from "@/components/Card"

import { useManualOrderFormContext } from ".."
import cls from "../AddManualOrderView.module.scss"

type ProcessingTimeReference = "pickup_in" | "pickup_at" | "delivery_at"

// function getDefaultSelectedTimeReference(order: Order) {
//   const { delivery_method, delivery_at } = order

//   if (delivery_method === "delivery_later" && delivery_at) return "delivery_at"
//   if (delivery_method === "own_delivery" && delivery_at) return "delivery_at"

//   return "pickup_at"
// }

const AVAILABLE_MINUTES = [10, 15, 20, 25, 30, 35, 40, 45, 50, 55]

export const CompletionTimeView = () => {
  const { orderKind, formState, setFormStateValue, setNextStep, setPreviousStep } = useManualOrderFormContext()

  const [selectedTime, setSelectedTime] = useState<number | null>(null)
  const [selectedTimeReference, setSelectedTimeReference] = useState<ProcessingTimeReference>("pickup_at")

  const [timeInputValue, setTimeInputValue] = useState(dayjs(formState.values.pickup_at).format("YYYY-MM-DDTHH:mm"))

  useEffect(() => {
    if (selectedTime) {
      setTimeInputValue(dayjs().add(selectedTime, "m").format("YYYY-MM-DDTHH:mm"))
    }
  }, [selectedTime])

  useEffect(() => {
    setFormStateValue({ pickup_at: dayjs(timeInputValue).format() })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeInputValue])

  function submitStep() {
    const { pickup_at } = formState.values || {}

    let errorsCount = 0

    toast.dismiss("timeValueError")

    if (!pickup_at) {
      errorsCount++

      toast.error("Wprowadź czas kompletacji", {
        toastId: "timeValueError",
        updateId: "timeValueError",
      })
    }

    if (dayjs(pickup_at).isBefore(dayjs().add(5, "m"))) {
      errorsCount++

      toast.error("Zbyt krótki czas kompletacji", {
        toastId: "timeValueError",
        updateId: "timeValueError",
      })
    }

    if (!errorsCount) setNextStep()
  }

  return (
    <Card className={cls.card}>
      <Card.Section>
        <h3>Wprowadź czas kompletacji</h3>
      </Card.Section>

      <Card.Section>
        <div className={cls.deliveryMethodSwitch}>
          {orderKind !== "delivery_only_now" && (
            <Button
              onClick={() => setSelectedTimeReference("pickup_at")}
              color={selectedTimeReference === "pickup_at" ? "primary" : "muted"}
              variation={selectedTimeReference === "pickup_at" ? "solid" : "accented"}
              size="large"
            >
              Odbiór
            </Button>
          )}

          {/* {orderKind !== "pickup_now" && (
            <Button
              color={selectedTimeReference === "delivery_at" ? "primary" : "muted"}
              variation={selectedTimeReference === "delivery_at" ? "solid" : "accented"}
              size="large"
              onClick={() => {
                setSelectedTimeReference("delivery_at")
                setSelectedTime(null)
              }}
            >
              Doręczenie
            </Button>
          )} */}
        </div>

        <h3>Czas kompletacji</h3>

        <div className={cls.timeBoxes}>
          {AVAILABLE_MINUTES.map((minutes) => (
            <TimeBox
              key={minutes}
              minutes={minutes}
              selected={selectedTime === minutes}
              disabled={selectedTimeReference !== "pickup_at"}
              setSelectedTime={setSelectedTime}
            />
          ))}
        </div>

        <h3>Godzina</h3>

        <div className={cls.inputs}>
          <div className={cls.wrapper}>
            <Input
              value={timeInputValue}
              onChange={(e) => {
                setTimeInputValue(e.currentTarget.value)
                setSelectedTime(null)
              }}
              className={cls.input}
              size="extra-large"
              type="datetime-local"
              required
            />

            {selectedTimeReference === "delivery_at" && (
              // values.delivery_at
              //  &&
              <span className={cls.upToRange}>
                <span className={cls.separator}>–</span>
                {/* {formatTime(getDateFromTime(values.delivery_at).add(30, "m"))} */}
              </span>
            )}
          </div>
        </div>
      </Card.Section>

      <Card.Section className={cls.submitBtns}>
        <Button
          className={cls.submitBtn}
          color="primary"
          variation="accented"
          size="extra-large"
          fullWidth
          onClick={setPreviousStep}
        >
          <Icon name="short-arrow-tiny-left" />
          Wstecz
        </Button>

        <Button className={cls.submitBtn} color="primary" size="extra-large" fullWidth onClick={submitStep}>
          Przejdź dalej
          <Icon name="short-arrow-tiny-right" />
        </Button>
      </Card.Section>
    </Card>
  )
}

type TimeBoxProps = {
  minutes: number
  selected: boolean
  disabled: boolean
  setSelectedTime: (minutes: number) => void
}

const TimeBox = ({ minutes, selected, disabled, setSelectedTime }: TimeBoxProps) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => setSelectedTime(minutes)}
      className={clsx(cls.timeBox, selected && cls.selected, disabled && cls.disabled)}
    >
      <div className={clsx("h600", cls.minutes)}>{minutes}</div>
      <div className={cls.label}>min</div>
    </button>
  )
}
